<template>
  <div class="text-page">
    <a v-on:click="leavePage()">
      <img class="close-icon" src="../assets/img/close-icon.svg" />
    </a>
    <h2 class="h2-custom">Metode og klassifisering</h2>
    <p>Det meste av datamaterialet som ligger til grunn for de genetiske analysene er basert på skjellprøver av voksen
      villaks der rømt oppdrettslaks er luket ut ved å studere vekstmønster i skjell. For prøver av ungfisk fanget i
      elven forutsetter vi at alle er født i elven og ikke rømt oppdrettslaks. Ved hjelp av genetiske markører som
      skiller mellom villaks og oppdrettslaks (Karlsson et al. 2011) estimeres for hvert enkelt individ sannsynligheten
      å tilhøre villaks versus oppdrettslaks (Karlsson et al. 2014). Gjennomsnittlig sannsynlighet for å tilhøre villaks
      beregnes for en stikkprøve fra en bestand. Prøvegjennomsnittet sammenlignes med historiske referanseprøver av
      villaks (før påvirkning av rømt oppdrettslaks) og prøver fra de ulike avlslinjene av oppdrettslaks (AquaGen AS,
      Salmobreed AS og Mowi ASA). Ut fra dette beregnes hvor stor andel av det samlede arvematerialet i bestanden som
      har opphav i rømt oppdrettslaks, angitt som innkryssing i prosent. </p>
    <p>For klassifisering av bestander har vi brukt følgende kriterier:</p>
    <ul>
      <li>Usikker: De genetiske analysene er basert på færre enn 20 individer</li>
      <li>Grønn (tilstand svært god eller god): Ingen genetiske endringer observert.
        <ul>
          <li>Ingen av de genetiske analysene indikerer innkryssing.</li>
        </ul>
      </li>
      <li>Gul (tilstand moderat): Svake genetiske endringer indikert.
        <ul>
          <li>Signifikansnivået for innkryssing ligger mellom 0,05 og 0,1 og/eller</li>
          <li>Signifikant andel individer fra stikkprøven har lave sannsynligheter for å tilhøre villaks, sett i forhold
            til fordelingen for historiske prøver, og/eller</li>
          <li>Estimert innkryssing er signifikant og ligger i intervallet 1 % til 4 %.</li>
        </ul>
      </li>
      <li>Oransje (tilstand dårlig): Moderate genetiske endringer påvist.
        <ul>
          <li>Signifikant innkryssing mellom 4 % og 10 %.</li>
        </ul>
      </li>
      <li>Rød (tilstand svært dårlig): Store genetiske endringer påvist.
        <ul>
          <li>Signifikant innkryssing over 10 %.</li>
        </ul>
      </li>
    </ul>
    <p>Prøven som viser den mest alvorlige tilstandsklassen er førende for klassifiseringen, gitt at prøven kommer fra ett av årene innenfor den siste laksegenerasjonen (6 år) som er undersøkt. Vi klassifiserer ikke bestanden dersom den nyeste prøven er mer enn tre laksegenerasjoner gammel. Vi forventer at beregnet innkryssing vil være høyere i ungfiskprøver enn i voksenfiskprøver fordi det er vist at innkryssede individer har lavere overlevelse i naturen enn ikke-innkryssede individer. Når vurderingen kun er gjort på ungfiskprøver har vi derfor brukt en bedre tilstandsklasse, og oftest «genetiske endringer indikert». </p>
    <p>Bestander med for lite data til å klassifisere er angitt med et hvitt symbol, mens bestander som ikke er undersøkt er markert med en svart prikk.</p>
    <p>For detaljert beskrivelse av metoden og klassifisering, se <a href="https://brage.nina.no/nina-xmlui/handle/11250/3108558" target="_blank" >NINA-rapport 2393</a>. </p>  
  </div>
</template>

<script>
import router from "../router.js";

export default {
  name: "methodAndClassification",
  props: {
    msg: String
  },
  methods: {
    leavePage() {
      router.push({ name: "watercourses" });
    }
  }
};
</script>
<style scoped lang="scss">
ul li {
	list-style-type: disc;
}

ul ul li {
	list-style-type: circle;
}
</style>
